import Login from '@/pages/auth/Login';

const authRoutes = [
  {
    path: '/auth/login',
    component: Login,
    name: 'sign-in',
  },
  {
    path: '/auth/logout',
    component: () => import(/* webpackChunckName: "auth" */ '../pages/auth/Logout'),
    name: 'sign-out',
  },
  {
    path: '/auth/password/request',
    component: () => import(/* webpackChunckName: "auth" */ '../pages/auth/ResetRequest'),
    name: 'request-reset',
  },
  {
    path: '/auth/password/reset',
    component: () => import(/* webpackChunckName: "auth" */ '../pages/auth/ResetPassword'),
    name: 'reset-password',
  },
];

export default authRoutes;
